import { MetaAdAccount, MetaPage, MetaPixel } from '../../../services/metaService';

/**
 * Estado da conexão Meta
 */
export interface MetaConnectionState {
    connecting: boolean;
    connected: boolean;
    accountName?: string;
    pixelName?: string;
    pageName?: string;
    expiresAt?: string;
}

export type MetaTokenStatus = 'valid' | 'expiring' | 'expired';

/** Status do token Meta com base na data de expiração. */
export function getMetaTokenStatus(expiresAt?: string): MetaTokenStatus {
    if (!expiresAt) return 'valid';

    const daysUntilExpiry = Math.ceil(
        (new Date(expiresAt).getTime() - Date.now()) / (1000 * 60 * 60 * 24),
    );

    if (daysUntilExpiry <= 0) return 'expired';
    if (daysUntilExpiry <= 7) return 'expiring';
    return 'valid';
}

/**
 * Dados para o modal de configuração
 */
export interface MetaModalData {
    accessToken: string;
    accounts: MetaAdAccount[];
    pages: MetaPage[];
    organizationId?: string;
}

/**
 * Seleção do usuário no modal
 */
export interface MetaSelectionData {
    account: MetaAdAccount;
    pixel: MetaPixel | null;
    page: MetaPage | null;
}

/**
 * Retorno do hook
 */
export interface UseMetaConnectionReturn {
    // Estado
    state: MetaConnectionState;
    modalData: MetaModalData | null;
    isModalOpen: boolean;
    isSaving: boolean;
    isTokenExpired: boolean;

    // Ações
    connect: () => Promise<void>;
    disconnect: () => Promise<void>;
    reconnect: () => Promise<void>;
    save: (selection: MetaSelectionData) => Promise<void>;
    closeModal: () => void;

    // Utilitários
    formatExpiryDate: (dateString?: string) => string | null;
}
